<template>
    <div>
        <!--<pageheading/>-->
        <welcome-g-a-image/>
        <div class="uk-padding">
            <div class="uk-container">
                <grad-requirements/>
            </div>
        </div>

        <!--<div class="uk-padding uk-background-muted">
            <div class="uk-container">
                <grad-student-opinions/>
            </div>
        </div>-->
        <alternate-grad-requirements/>
        <explore-grad-programs/>
        <incomplete-applications/>


    </div>
</template>

<script>
    import Pageheading from "../components/shared/pageheading";
    import WelcomeGAImage from "../components/graduateadmission/welcomeGAImg";
    import GradRequirements from "../components/graduateadmission/GradRequirements";
    import GradStudentOpinions from "../components/graduateadmission/GradStudentOpinions";
    import ExploreGradPrograms from "../components/graduateadmission/exploreGradPrograms";
    import AlternateGradRequirements from "../components/graduateadmission/alternateGradRequirements";
    import IncompleteApplications from "../components/shared/incompleteApplications";
    export default {
        name: "GraduateAdmission",
        components: {
            IncompleteApplications,
            AlternateGradRequirements,
            ExploreGradPrograms, GradStudentOpinions, GradRequirements, WelcomeGAImage, Pageheading}
    }
</script>

<style scoped>

</style>